import React from 'react';
import { IEntityStore, IHarmonizationRepo, ISupplier } from '../../../main/entities';
import { IEntityStateAgg } from '../../../main/useEntityStateAgg';
import { SupplierItemExtended } from './SupplierItemExtended';

interface HarmoState {
	slaveSupplierAgg: IEntityStateAgg<ISupplier>
	masterItem: SupplierItemExtended|undefined
	setMasterItemId(masterItemId: number) : void
	harmonizationRepo: IHarmonizationRepo
	registeredSupplierRepo: IEntityStore<ISupplier>
	masterSupplierItemExtendedRepo: IEntityStore<SupplierItemExtended>
}

const context = React.createContext<HarmoState>(null as any);

export function HarmoStateProvider(props: {value: HarmoState, children: React.ReactNode}) {
	const {value, children} = props;
	return <context.Provider value={value}>{children}</context.Provider>;
}

export const useHarmoState = () => React.useContext(context);
